"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

var _excluded = ["className", "defaultValue", "disable", "id", "name", "onChange", "placeholder", "type", "startAdornment", "endAdornment"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Text = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      inputStyles = _useState2[0],
      setInputStyles = _useState2[1];

  var startAdornmentRef = (0, _react.useRef)(null);
  var endAdornmentRef = (0, _react.useRef)(null);

  var classNameProp = props.className,
      defaultValue = props.defaultValue,
      disable = props.disable,
      id = props.id,
      name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder,
      type = props.type,
      startAdornment = props.startAdornment,
      endAdornment = props.endAdornment,
      rest = _objectWithoutProperties(props, _excluded);

  var className = (0, _clsx["default"])('od-text-field', 'medium', {
    'od-start-adornment': (startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.type) || (startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.customAdornment),
    'od-end-adornment': (endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.type) || (endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.customAdornment)
  }, classNameProp);
  var startAdornmentClassName = (0, _clsx["default"])('od-text-field__icon-container', 'od-start-adornment', {
    'od-icon-clickable': startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.onClick
  }, startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.containerClassName);
  var endAdornmentClassName = (0, _clsx["default"])('od-text-field__icon-container', 'od-end-adornment', {
    'od-icon-clickable': endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.onClick
  }, endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.containerClassName);

  var noop = function noop() {};

  (0, _react.useEffect)(function () {
    var _startAdornmentRef$cu, _startAdornmentRef$cu2, _endAdornmentRef$curr, _endAdornmentRef$curr2;

    var updateStyles = {};
    if (startAdornmentRef !== null && startAdornmentRef !== void 0 && (_startAdornmentRef$cu = startAdornmentRef.current) !== null && _startAdornmentRef$cu !== void 0 && _startAdornmentRef$cu.clientWidth) updateStyles.paddingLeft = String((startAdornmentRef === null || startAdornmentRef === void 0 ? void 0 : (_startAdornmentRef$cu2 = startAdornmentRef.current) === null || _startAdornmentRef$cu2 === void 0 ? void 0 : _startAdornmentRef$cu2.clientWidth) + 10) + 'px';
    if (endAdornmentRef !== null && endAdornmentRef !== void 0 && (_endAdornmentRef$curr = endAdornmentRef.current) !== null && _endAdornmentRef$curr !== void 0 && _endAdornmentRef$curr.clientWidth) updateStyles.paddingRight = String((endAdornmentRef === null || endAdornmentRef === void 0 ? void 0 : (_endAdornmentRef$curr2 = endAdornmentRef.current) === null || _endAdornmentRef$curr2 === void 0 ? void 0 : _endAdornmentRef$curr2.clientWidth) + 10) + 'px';
    setInputStyles(function (styles) {
      return _objectSpread(_objectSpread({}, styles), updateStyles);
    });
  }, [startAdornmentRef, endAdornmentRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "od-text-field__container"
  }, startAdornment !== null && startAdornment !== void 0 && startAdornment.type || startAdornment !== null && startAdornment !== void 0 && startAdornment.customAdornment ? /*#__PURE__*/_react["default"].createElement("span", {
    ref: startAdornmentRef,
    className: startAdornmentClassName,
    onClick: (startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.onClick) || noop
  }, (startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.customAdornment) || null, /*#__PURE__*/_react["default"].createElement(_PayUIcons["default"], {
    type: startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.type,
    size: (startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.size) || '12px',
    color: startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.color
  })) : null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: className,
    style: inputStyles,
    defaultValue: defaultValue,
    disable: disable ? 'true' : 'false',
    id: id,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    ref: ref,
    type: type
  }, rest)), endAdornment !== null && endAdornment !== void 0 && endAdornment.type || endAdornment !== null && endAdornment !== void 0 && endAdornment.customAdornment ? /*#__PURE__*/_react["default"].createElement("span", {
    ref: endAdornmentRef,
    className: endAdornmentClassName,
    onClick: (endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.onClick) || noop
  }, (endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.customAdornment) || null, /*#__PURE__*/_react["default"].createElement(_PayUIcons["default"], {
    type: endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.type,
    size: (endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.size) || '12px',
    color: endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.color
  })) : null);
});

Text.propTypes = {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  disable: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string,
  startAdornment: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    size: _propTypes["default"].string,
    color: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    customAdornment: _propTypes["default"].node
  }),
  endAdornment: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    size: _propTypes["default"].string,
    color: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    customAdornment: _propTypes["default"].node
  })
};
Text.defaultProps = {
  className: '',
  defaultValue: '',
  disable: false,
  id: '',
  name: '',
  onChange: function onChange() {},
  placeholder: '',
  type: 'text'
};
var _default = Text;
exports["default"] = _default;